/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { PayTypeDto } from './payTypeDto.schema';

export const IReadOnlyListOfPayTypeDto = zod.array(zod.lazy(() => PayTypeDto));

export type IReadOnlyListOfPayTypeDto = zod.input<typeof IReadOnlyListOfPayTypeDto>;
export type IReadOnlyListOfPayTypeDtoOutput = zod.output<typeof IReadOnlyListOfPayTypeDto>;
